export default "__VITE_ASSET__Dy3i5yls__"